<template>
    <v-form v-model="is_valid"
            :disabled="loading">
        <v-container class="base container-fuid">
            <h1>Desabilitar a autenticação via aplicativo</h1>
            <v-row>
                <v-col>
                    <p>
                        Desabilitar a autenticação não afeta as chaves utilizadas
                        para sua entrada no sistema. Para redefinir as chaves
                        <router-link to="./reset-2fa">
                            reinicialize as informações de autenticação
                        </router-link>.
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn @click="disable2FA">Desabilitar</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<style lang="css">
</style>

<style lang="css" scoped>
</style>

<script lang="js">
import ApiService from '@/services/ApiService';

export default              {
    data                    () {
        return              {
            api             : undefined,
            is_valid        : false,
            loading         : false
        }
    },
    methods                 : {
        async disable2FA    () {
            try {
                this.loading = true;
                const resp = await this.api.mfaDisableAuthenticator();
                if (!resp.success) {
                    this.$toast.error(resp.message || 'Falha não identificada ao desabilitar.');
                    return;
                }
                this.$toast.info(
                    resp.message ||
                    'Acesso via aplicativo desabilitado. Redirecionando...');
                setTimeout(() => this.$router.push({ path: '/' }), 2000);
            } finally {
                this.loading = false;
            }
        }
    },
    mounted                 () {
        this.api = new ApiService();
    }
}
</script>